
    import store from '@/store'
    import AuthService from '@/service/AuthService';

    export default {
        name: 'IpCheck',
        computed: {
            isOversea() { return (this.info.CNTR_CD || '').toUpperCase() === 'KR' },
        },
        data() {
            return {
                visible: false,
                info: {},
            }
        },
        methods: {
            show() {
                this.visible = true;
                this.$root.setLoading(true);
            },
            hide() {
                this.visible = false;
                this.$root.setLoading(false);
            },
            get() {
                return AuthService.ipInfo().then(({ data }) => {
                    if (data.success) {
                        this.info = data;
                        store.dispatch('setIpInfo', { data });
                    }
                });
            }
        },
        mounted() {

        }
    }
